/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface KoreaWaybillVo
 */
export interface KoreaWaybillVo {
    /**
     * 运单号
     * @type {string}
     * @memberof KoreaWaybillVo
     */
    ivcNo?: string;
    /**
     * 当前时间
     * @type {string}
     * @memberof KoreaWaybillVo
     */
    now?: string;
    /**
     * 总箱数
     * @type {number}
     * @memberof KoreaWaybillVo
     */
    totalBoxCount?: number;
    /**
     * 子运单号
     * @type {Array<string>}
     * @memberof KoreaWaybillVo
     */
    subIvcNo?: Array<string>;
    /**
     * 收货人姓名
     * @type {string}
     * @memberof KoreaWaybillVo
     */
    receiveNameKr?: string;
    /**
     * 收货地址
     * @type {string}
     * @memberof KoreaWaybillVo
     */
    receiveAddress?: string;
    /**
     * 手机号
     * @type {string}
     * @memberof KoreaWaybillVo
     */
    receiveMobileNo?: string;
    /**
     * 总商品数量
     * @type {number}
     * @memberof KoreaWaybillVo
     */
    totalGoodsQuantity?: number;
    /**
     * cj单号
     * @type {string}
     * @memberof KoreaWaybillVo
     */
    cjCode?: string;
    /**
     * cj单号-子
     * @type {string}
     * @memberof KoreaWaybillVo
     */
    cjCodeSub?: string;
    /**
     * cj数据
     * @type {string}
     * @memberof KoreaWaybillVo
     */
    dlvPreArrBranShortNm?: string;
    /**
     * 发货仓库
     * @type {string}
     * @memberof KoreaWaybillVo
     */
    sendWarehouse?: string;
    /**
     * 发货仓库地址
     * @type {string}
     * @memberof KoreaWaybillVo
     */
    sendWarehouseAddress?: string;
    /**
     * 发货人手机号
     * @type {string}
     * @memberof KoreaWaybillVo
     */
    senderMobileNo?: string;
}

/**
 * Check if a given object implements the KoreaWaybillVo interface.
 */
export function instanceOfKoreaWaybillVo(value: object): value is KoreaWaybillVo {
    return true;
}

export function KoreaWaybillVoFromJSON(json: any): KoreaWaybillVo {
    return KoreaWaybillVoFromJSONTyped(json, false);
}

export function KoreaWaybillVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): KoreaWaybillVo {
    if (json == null) {
        return json;
    }
    return {
        
        'ivcNo': json['ivcNo'] == null ? undefined : json['ivcNo'],
        'now': json['now'] == null ? undefined : json['now'],
        'totalBoxCount': json['totalBoxCount'] == null ? undefined : json['totalBoxCount'],
        'subIvcNo': json['subIvcNo'] == null ? undefined : json['subIvcNo'],
        'receiveNameKr': json['receiveNameKr'] == null ? undefined : json['receiveNameKr'],
        'receiveAddress': json['receiveAddress'] == null ? undefined : json['receiveAddress'],
        'receiveMobileNo': json['receiveMobileNo'] == null ? undefined : json['receiveMobileNo'],
        'totalGoodsQuantity': json['totalGoodsQuantity'] == null ? undefined : json['totalGoodsQuantity'],
        'cjCode': json['cjCode'] == null ? undefined : json['cjCode'],
        'cjCodeSub': json['cjCodeSub'] == null ? undefined : json['cjCodeSub'],
        'dlvPreArrBranShortNm': json['dlvPreArrBranShortNm'] == null ? undefined : json['dlvPreArrBranShortNm'],
        'sendWarehouse': json['sendWarehouse'] == null ? undefined : json['sendWarehouse'],
        'sendWarehouseAddress': json['sendWarehouseAddress'] == null ? undefined : json['sendWarehouseAddress'],
        'senderMobileNo': json['SenderMobileNo'] == null ? undefined : json['SenderMobileNo'],
    };
}

export function KoreaWaybillVoToJSON(json: any): KoreaWaybillVo {
    return KoreaWaybillVoToJSONTyped(json, false);
}

export function KoreaWaybillVoToJSONTyped(value?: KoreaWaybillVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ivcNo': value['ivcNo'],
        'now': value['now'],
        'totalBoxCount': value['totalBoxCount'],
        'subIvcNo': value['subIvcNo'],
        'receiveNameKr': value['receiveNameKr'],
        'receiveAddress': value['receiveAddress'],
        'receiveMobileNo': value['receiveMobileNo'],
        'totalGoodsQuantity': value['totalGoodsQuantity'],
        'cjCode': value['cjCode'],
        'cjCodeSub': value['cjCodeSub'],
        'dlvPreArrBranShortNm': value['dlvPreArrBranShortNm'],
        'sendWarehouse': value['sendWarehouse'],
        'sendWarehouseAddress': value['sendWarehouseAddress'],
        'SenderMobileNo': value['senderMobileNo'],
    };
}

